import { useRoles } from "@/hooks/useRoles";
import { Loading } from "@/components/Page/Loading";
import { Forbidden } from "@/components/Page/Forbidden";
import { useIsSuperAdmin } from "@/hooks/useIsSuperAdmin";
import { UsersTable } from "@/components/Users/Users.table";

const UsersPage = () => {
  const { isSuperAdmin, isAdmin, isInitialized } = useRoles();
  useIsSuperAdmin();

  if (!isInitialized) return <Loading />;
  if (isInitialized && !(isSuperAdmin || isAdmin)) return <Forbidden />;

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <div className="flex flex-row gap-2">
        <h1 className="text-2xl">Users</h1>
      </div>
      <div className="overflow-auto">
        <UsersTable />
      </div>
    </div>
  );
};

export default UsersPage;
